import { useQuery } from '@tanstack/react-query';

import { prophetTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';
import { isValidObjectId } from '@/utils';

export const getProphetRules: prophetTypes.GetProphetRules = (params) => {
  return axios.get('/prophet/rules', { params });
};

type QueryFnType = typeof getProphetRules;

type UseGetProphetRulesOptions = {
  pageId?: string;
  config?: QueryConfig<QueryFnType>;
};

export const useGetProphetRules = ({ config = {}, pageId }: UseGetProphetRulesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['prophet-rules', pageId],
    enabled: !!pageId,
    queryFn: () => {
      if (!pageId) {
        throw new Error('Page ID is required');
      }
      if (!isValidObjectId(pageId)) {
        throw new Error('Invalid Page ID');
      }
      return getProphetRules({ pageId });
    },
  });
};
